/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgMenuArrowLeftBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5789 13.3549C10.1647 13.3549 9.82891 13.6907 9.82891 14.1049C9.82891 14.5191 10.1647 14.8549 10.5789 14.8549V13.3549ZM21 14.8549C21.4142 14.8549 21.75 14.5191 21.75 14.1049C21.75 13.6907 21.4142 13.3549 21 13.3549V14.8549ZM10.5789 18.25C10.1647 18.25 9.82891 18.5858 9.82891 19C9.82891 19.4142 10.1647 19.75 10.5789 19.75V18.25ZM21 19.75C21.4142 19.75 21.75 19.4142 21.75 19C21.75 18.5858 21.4142 18.25 21 18.25V19.75ZM3.9473 8.45978C3.53309 8.45978 3.1973 8.79557 3.1973 9.20978C3.1973 9.624 3.53309 9.95978 3.9473 9.95978V8.45978ZM21 9.95978C21.4142 9.95978 21.75 9.624 21.75 9.20978C21.75 8.79557 21.4142 8.45978 21 8.45978V9.95978ZM6.868 5.45626C7.11998 5.1275 7.05775 4.65673 6.729 4.40474C6.40025 4.15276 5.92947 4.21499 5.67748 4.54374L6.868 5.45626ZM3 9.26981L2.40474 8.81355C2.19678 9.08487 2.1986 9.4625 2.40918 9.7318L3 9.26981ZM5.68192 13.9172C5.93707 14.2435 6.40843 14.3012 6.73473 14.046C7.06103 13.7909 7.11871 13.3195 6.86356 12.9932L5.68192 13.9172ZM10.5789 14.8549H21V13.3549H10.5789V14.8549ZM10.5789 19.75H21V18.25H10.5789V19.75ZM3.9473 9.95978H21V8.45978H3.9473V9.95978ZM5.67748 4.54374L2.40474 8.81355L3.59526 9.72606L6.868 5.45626L5.67748 4.54374ZM2.40918 9.7318L5.68192 13.9172L6.86356 12.9932L3.59082 8.80782L2.40918 9.7318Z"
      fill="currentColor"
    />
  </svg>
);
const SvgMenuArrowLeft = wrapIcon(SvgMenuArrowLeftBase);
export default SvgMenuArrowLeft;
